module.exports = __webpack_public_path__ + "img/icon-doc.a8417f34.svg";